<template>
  <el-container class="page-container">
    <!-- 左侧：树形菜单 -->
    <el-aside width="250px" class="left-aside">
      <div class="toolbar">
        <div class="toolbar-left">
          <el-button type="primary" icon="el-icon-refresh" size="small" @click="getSFTPData('true')">获取</el-button>
          <el-button type="success" icon="el-icon-download" size="small" :loading="this.downloading" @click="handleDownloadFromFtp">下载
          </el-button>
        </div>
      </div>
      <div class="tree-wrapper">
        <!-- 树组件：根据实际 bspTree 或 el-tree 替换 -->
        <el-tree
          ref="fileTree"
          :data="treeData"
          :props="defaultProps"
          node-key="filId"
          :default-expand-all="true"
          :expand-on-click-node="false"
          :highlight-current="true"
          :check-strictly="false"
          @node-click="handleNodeClick"
        ></el-tree>
      </div>
    </el-aside>

    <!-- 右侧：主要内容区 -->
    <el-main class="right-main">
      <!-- 1. 顶部工具栏 (完全还原截图布局) -->
      <div class="toolbar">
        <div class="toolbar-left">
          <el-button icon="el-icon-refresh" size="small" @click="handleRefresh">刷新</el-button>
          <el-button type="success" icon="el-icon-download" size="small" :disabled="multipleSelection.length === 0"
                     @click="downloadHistoryRecord">下载
          </el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" :disabled="multipleSelection.length === 0"
                     @click="handleDelete">删除
          </el-button>
        </div>

        <div class="toolbar-right">
          <span class="upload-label">选择要上传的文件</span>
          <!-- 隐藏的文件输入框 -->
          <input
            ref="fileInput"
            type="file"
            style="display: none"
            @change="handleFileChange"
          />
          <!-- 模拟截图中的按钮样式 -->
          <el-button class="button-v2" type="primary" size="small" @click="$refs.fileInput.click()">选择文件</el-button>

          <span class="file-name-display">{{ uploadFileName || '未选择文件' }}</span>

          <el-button class="button-v2" type="primary" size="small" icon="el-icon-upload2" :disabled="!uploadFile"
                     @click="handleUpload">上传
          </el-button>
        </div>
      </div>

      <!-- 2. 数据表格区域 (使用封装的 bspTable) -->
      <div class="table-wrapper table-body flex vertical">
        <bsp-table
          ref="bspTable"
          :data.sync="tableData" :ciic-data-filter.sync="listQuery"
          v-loading="tableLoading"
          border
          stripe
          @checkbox-change="selectChange"
          @checkbox-all="selectAll" @ciic-data-refresh="loadData"
          show-overflow
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          show-footer-overflow
          show-footer :showPagination="listQuery.page"
          fixed="left"
        >
          <!-- 复选框列 -->
          <bsp-table-column type="selection" width="55" align="center"></bsp-table-column>

          <!-- 文件名 -->
          <bsp-table-column label="文件名" prop="fileName" align="left">
            <template slot-scope="scope">
              <i class="el-icon-document" style="margin-right: 5px; color: #409EFF;"></i>
              {{ scope.row.fileName }}
            </template>
          </bsp-table-column>

          <!-- 获取日期 -->
          <bsp-table-column label="获取日期" prop="fileInsertDate" align="left">
            <template slot-scope="scope"><span>{{ scope.row.fileInsertDate }}</span></template>
          </bsp-table-column>
        </bsp-table>
      </div>
    </el-main>
  </el-container>
</template>

<script>
// 引入 API 接口
import {
  queryAllFile,
  queryHistoryRecord,
  deleteHistoryRecord,
  downloadFiles,
  uploadSeagateFile,
  downloadHistoryRecord
} from '@/api/seagate/fileDownload';
import bspTable from "@/components/bsp/bsp-table/bsp-table";
import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";

export default {
  name: 'FileManager',
  components: {bspTableColumn, bspTable},
  data() {
    return {
      // --- 树相关 ---
      treeLoading: false,
      treeData: [],
      defaultProps: {children: 'children', label: 'fileName'},
      currentFolderId: null,

      // --- 表格相关 ---
      tableData: [],
      tableLoading: false,
      multipleSelection: [],

      // 分页配置 (传给 bspTable 内部处理)
      listQuery: {
        page: 1,
        limit: 50,
        total: 0
      },

      // --- 上传相关 ---
      uploadFile: null,
      uploadFileName: '',
      uploadLoading: false,

      // 下载相关
      downLoading: false,
      selectedNode: {
        downloadFileId: "-1",           // 固定为 -1
        downloadFilePath: "",            // 根节点路径（可能为空）
        downloadFileName: "Files",       // 根节点名称
        isFolder: "true",                // 固定为文件夹
        downloadFileChildren: [] // 整棵树
      }
    };
  },
  created() {
    this.initTree();
    this.loadData();
  },
  methods: {
    // 1. 初始化树
    initTree() {
      this.getSFTPData(false);
    },

    // 2. 加载表格数据
    loadData() {
      this.tableLoading = true;
      let params = {
        pageNum: '1',
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        ...this.listQuery
      }
      queryHistoryRecord(params).then(res => {
        this.listQuery.total = res.data.total
        this.tableData = res.data.records
        this.multipleSelection = [];
      }).catch(() => {
        this.$message.error('加载列表失败');
      }).finally(() => {
        this.tableLoading = false;
      });
    },


    // 获取 SFTP 数据
    getSFTPData(refreshFlag) {
      // 显示加载遮罩
      this.treeLoading = true;

      // 构建参数 - 与原 JSP 保持一致
      const params = {
        refreshFlag: refreshFlag
      };
      // 调用获取树数据的接口
      queryAllFile(params).then(res => {
        // 检查返回数据中的 messageFlag
        if (res.data.messageFlag === 'false') {
          this.$confirm('SFTP登录超时，请确定是否重新拉取！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 点击确认
            this.getSFTPData(refreshFlag);
          }).catch(() => {
          });
        }
        // 更新树数据
        // 🔥 关键：将扁平数据转换为树形结构
        const flatData = res.data.treeList || [];
        this.treeData = this.buildTree(flatData, '0');

      }).catch(() => {
        this.$message.error('获取数据失败');
      }).finally(() => {
        // 关闭遮罩
        this.treeLoading = false;
      });
    },

    // 将一维的扁平数组转换为多层级对象
    buildTree(flatData, rootPid = '0') {
      const map = {};
      const result = [];

      flatData.forEach(node => {
        map[node.fileId] = {
          ...node,
          children: []
        };
      });

      flatData.forEach(node => {
        const currentNode = map[node.fileId];
        let parentId = node.pid;

        // 🔥 如果父节点是 '-1'，将其转换为虚拟根节点的 fileId
        // 但虚拟根节点本身已经在 result 中，所以需要把节点挂到虚拟根下面
        if (String(parentId) === '-1') {
          // 找到虚拟根节点（fileId 为 '-1' 的节点）
          const virtualRoot = map['-1'];
          if (virtualRoot) {
            virtualRoot.children.push(currentNode);
          } else {
            // 如果虚拟根不存在，直接作为根节点
            result.push(currentNode);
          }
        } else if (String(parentId) === String(rootPid)) {
          result.push(currentNode);
        } else {
          const parentNode = map[parentId];
          if (parentNode) {
            parentNode.children.push(currentNode);
          } else {
            result.push(currentNode);
          }
        }
      });

      return result;
    },

    // 下载历史文件
    downloadHistoryRecord() {
      this.downLoading = true
      const ids = this.multipleSelection.map(row => row.fileId);
      const fileIds = ids.join(',');
      let params = {
        fileIds: fileIds
      }
      downloadHistoryRecord(params).then(res => {
        this.$downloadFile(res)
      }).catch(() => {
        this.$message.error('下载失败');
      }).finally(() => {
        this.downLoading = false;
      });
    },

    // 3. 事件处理
    // 复选框单选事件
    selectChange({checked, row}) {
      if (checked) {
        this.multipleSelection.push(row)
      }
      if (!checked) {
        this.multipleSelection.filter((item, index) => {
          if (item.fileId === row.fileId) {
            this.multipleSelection.splice(index, 1)
          }
        })
      }
    },
    //复选框全选事件
    selectAll({checked, selection}) {
      if (checked) {
        let i = 0;
        this.multipleSelection = [];
        for (i; i < selection.length; i++) {
          this.multipleSelection.push(selection[i]);
        }
      } else {
        this.multipleSelection = [];
      }
    },

    handleRefresh() {
      this.listQuery.page = 1;
      this.loadData();
    },

    // 4. 业务操作：删除
    handleDelete() {
      const ids = this.multipleSelection.map(row => row.fileId);
      const fileIds = ids.join(',');
      this.$confirm(`确定删除选中的 ${ids.length} 个文件吗?`, '提示', {type: 'warning'}).then(() => {
        deleteHistoryRecord({fileIds: fileIds}).then(() => {
          this.$message.success('删除成功');
          this.loadData();
        });
      });
    },

    // 5. 业务操作：下载
    handleDownloadFromFtp() {
      if(this.treeData == null || this.treeData.length === 0) {
        this.$message.warning('没有数据可下载');
        return;
      }
      this.downLoading = true;
      // 获取整棵树数据
      const treeData = this.treeData

      // 提取根节点（Files）下的所有子节点，但不包含 Files 本身
      const rootChildren = treeData && treeData.length > 0 ? treeData[0].children || [] : []
      const params = {
        downloadFileId: "-1",           // 固定为 -1
        downloadFilePath: "",            // 根节点路径（可能为空）
        downloadFileName: "Files",       // 根节点名称
        isFolder: "true",                // 固定为文件夹
        downloadFileChildren: JSON.stringify(rootChildren) // 整棵树
      }
      // 通常下载直接跳转链接或使用 blob 流
      downloadFiles(params).then(res => {
        this.$downloadFile(res)
      }).catch(() => {
        this.$message.error('下载失败');
      }).finally(() => {
        this.downLoading = false;
        this.initTree();
        this.loadData();
      });
    },

    // 6. 业务操作：上传逻辑
    handleFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.uploadFile = file;
        this.uploadFileName = file.name;
      }
    },

    handleUpload() {
      if (!this.uploadFile) return;
      let loadingInstance = this.$loading({
        fullscreen: true, // 全屏
        text: '正在上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.uploadLoading = true;
      // 再次检查文件大小（防止绕过前端校验）
      const maxSize = 10 * 1024 * 1024;
      if (this.uploadFile.size > maxSize) {
        this.$message.error('文件大小超过限制');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.uploadFile);
      formData.append('filename', this.uploadFileName);

      uploadSeagateFile(formData).then(() => {
        this.$message.success('上传成功');
        // 重置上传控件
        this.uploadFile = null;
        this.uploadFileName = '';
        this.$refs.fileInput.value = '';
        this.loadData();
      }).catch(() => {
        this.$message.error('文件上传失败');
      }).finally(() => {
        this.uploadLoading = false;
        loadingInstance.close()
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 100% !important;
  padding: 0 !important;
  border-radius: 6px !important;
  background-color: #FFFFFF !important;
}

.left-aside {
  border-right: 1px solid #e6e6e6;
  background-color: #fbfbfb;
}

.tree-wrapper {
  padding: 10px;
  height: 100%;
  overflow-y: auto;
}

.right-main {
  padding: 0;
  display: flex;
  flex-direction: column;
}

/* 工具栏样式 */
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #e6e6e6;
  background-color: #f5f7fa;
}

.toolbar-left .el-button {
  margin-right: 8px;
}

.toolbar-right {
  display: flex;
  align-items: center;
}

.upload-label {
  font-size: 12px;
  color: #606266;
  margin-right: 8px;
}

.file-name-display {
  margin: 0 10px;
  font-size: 12px;
  color: #909399;
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 表格容器 */
.table-wrapper {
  flex: 1;
  padding: 10px;
  overflow: hidden; /* 防止双重滚动条 */
}
</style>
